import React from 'react';
import { APITypes } from '../../../primary-record-types';
import urls from '../../../utils/urls';
import HeaderContainer from '../../v2BaseComponents/HeaderContainer';
import Stack, { contentStackSpacing } from '../../v2BaseComponents/Stack';
import { LoadableAvatar } from '../../v2BaseComponents/Avatar';
import Text from '../../v2BaseComponents/Text';
import getName from '../../../utils/getName';

export type AccountHeaderOwnProps = {
    user: APITypes.userService.MeResponse;
};

export type AccountHeaderProps = AccountHeaderOwnProps;

const AccountHeader: React.FC<AccountHeaderProps> = ({ user }) => {
    return (
        <HeaderContainer>
            <Stack horizontal fullWidth align="center" justify="flex-start" space={2.5}>
                <LoadableAvatar
                    avatarUrl={urls.api.users.avatar}
                    size="md"
                    firstName={user.preferredName || user.firstName}
                    lastName={user.lastName}
                />
                <Stack vertical space={contentStackSpacing}>
                    <Text variant="h4">{getName(user)}</Text>
                    <Text variant="caption-1">{user.email}</Text>
                </Stack>
            </Stack>
        </HeaderContainer>
    );
};

export default React.memo(AccountHeader);
